import type { PaymentDetailData } from "../types/consultationsBilling.types";

const ORIGINAL_SERVICE_COST_URL =
  "http://fluxmed.com.br/fhir/StructureDefinition/OriginalServiceCost";

const SCHEDULE_SERVICE_COST_URL =
  "https://fluxmed.com.br/fhir/StructureDefinition/service-cost";

function parseMonetaryInput(value: unknown): number | null {
  if (value == null || value === "") return null;
  if (typeof value === "number" && Number.isFinite(value)) return value;

  let normalized = String(value).replace(/R\$\s?/g, "").trim();
  if (!normalized) return null;

  if (normalized.includes(",")) {
    normalized = normalized.replace(/\./g, "").replace(",", ".");
  }

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatStatsCurrency(value: number) {
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function getPaymentNoticeMonetaryValue(
  payment: fhir5.PaymentNotice
): number {
  const amountValue = parseMonetaryInput(payment.amount?.value);
  if (amountValue != null && amountValue > 0) return amountValue;

  const originalCostExt = payment.extension?.find(
    (ext) => ext.url === ORIGINAL_SERVICE_COST_URL
  );
  const extensionValue = parseMonetaryInput(
    originalCostExt?.valueDecimal ?? originalCostExt?.valueInteger
  );
  if (extensionValue != null && extensionValue > 0) return extensionValue;

  return amountValue ?? 0;
}

export function getScheduleServiceCost(
  schedule?: fhir5.Schedule | null
): number {
  if (!schedule) return 0;
  const serviceCostExt = schedule.extension?.find(
    (ext) => ext.url === SCHEDULE_SERVICE_COST_URL
  );
  const parsed = parseMonetaryInput(serviceCostExt?.valueDecimal);
  return parsed != null && parsed > 0 ? parsed : 0;
}

export function getChargeAmount(detail: PaymentDetailData): number {
  const fromNotice = getPaymentNoticeMonetaryValue(detail.payment);
  if (fromNotice > 0) return fromNotice;
  return getScheduleServiceCost(detail.schedule);
}

export function sumPaymentDetailsAmount(payments: PaymentDetailData[]): number {
  return payments.reduce((sum, entry) => sum + getChargeAmount(entry), 0);
}
